import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { get_all_employee_attendance } from './../../../../app/pages/Employees/attendance/api/attendanceApi';
import { get_all_attendance_types } from '../../../../app/pages/Settings/attendance-types/api/attendanceTypeApi';
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider';
import { KTIcon } from '../../../helpers';
import { formatDateWithTime, formatDateWithTimeAttendance, formatDateAttendance } from '../../../../app/helper-functions/DateFunction';
import { Attendance } from '../../../../app/modules/accounts/components/settings/SettingsModel';
import { get_all_active_attendance_type } from '../../../../app/pages/Employees/api/PersonalDetailsApi';

type Props = {
  className: string;
};

const ChartsWidget1: React.FC<Props> = ({ className }) => {
  const { mode } = useThemeMode();
  const [attendanceList, setAttendanceList] = useState<Attendance[]>([]);
  const [firstCheckInTime, setFirstCheckInTime] = useState<string>('N/A');
  const [currentAttendanceType, setCurrentAttendanceType] = useState<string>('N/A');
  const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}');
  const currentUserId = authData.user.id;

  const { data: attendanceData, isLoading: isAttendanceLoading, isError: isAttendanceError } = useQuery(
    ['allattendance'],
    () => get_all_employee_attendance()
  );

  const { data: attendanceTypeData } = useQuery('get_all_active_attendance_type', get_all_active_attendance_type, {
    refetchOnWindowFocus: false,
  });
  useEffect(() => {
    if (attendanceData?.data && Object.keys(attendanceData.data).length !== 0) {
      const attendanceRecords = attendanceData.data;
  
      // Save check using JSON.stringify
      if (JSON.stringify(attendanceRecords) !== JSON.stringify(attendanceList)) {
        setAttendanceList(attendanceRecords);
      }
  
      const today = new Date();
      const todayDate = formatDateAttendance(today);
      const todayAttendances = attendanceRecords.filter(
        (att) => formatDateAttendance(new Date(att.attendance_datetime)) === todayDate
      );
  
      if (todayAttendances.length > 0) {
        const firstAttendance = todayAttendances.reduce((earliest, current) =>
          new Date(earliest.attendance_datetime) < new Date(current.attendance_datetime) ? earliest : current
        );
        setFirstCheckInTime(formatDateWithTimeAttendance(new Date(firstAttendance.attendance_datetime)));
  
        const latestAttendance = todayAttendances.reduce((latest, current) =>
          new Date(latest.attendance_datetime) > new Date(current.attendance_datetime) ? latest : current
        );
        const currentAttendanceType = latestAttendance.attendance_type_name || 'N/A';
        setCurrentAttendanceType(
          `${currentAttendanceType} (${formatDateWithTimeAttendance(new Date(latestAttendance.attendance_datetime))})`
        );
      }
    }
  }, [attendanceData]);
  
  const totalAttendances = attendanceList.length;
  const todayShift = attendanceList.length > 0 ? attendanceList[0].shift_name : 'No shift found for today';
  const lastUpdate = attendanceList.length > 0 ? formatDateWithTime(attendanceList[0].updated_at) : 'N/A';
  const today = new Date();
  const todayDate = formatDateAttendance(today);

  return (
    <div className={`card ${className}`}>
      <div className="card-header border-0 pt-5">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label fw-bolder fs-3 mb-1">
            Attendance Overview {authData?.user?.full_name}
          </span>
          <span className="text-muted mt-1">Date: {todayDate}</span>
        </h3>
      </div>

      <div className="card-body py-3">
        <div className="row mb-5">
          <OverviewCard
            color="success"
            icon="clock"
            title="Shifts"
            value={isAttendanceLoading ? 'Loading...' : todayShift}
          />
          <OverviewCard
            color="info"
            icon="clock"
            title="Today's First Check-In Time"
            value={isAttendanceLoading ? 'Loading...' : firstCheckInTime}
          />
          <OverviewCard
            color="primary"
            icon="check-circle"
            title="Current Attendance Type and Time"
            value={isAttendanceLoading ? 'Loading...' : currentAttendanceType}
          />
        </div>
        {isAttendanceError && (
          <div className="alert alert-danger mt-5" role="alert">
            Error loading data. Please try again later.
          </div>
        )}
      </div>
    </div>
  );
};

type OverviewCardProps = {
  color: 'primary' | 'success' | 'warning' | 'info';
  icon: string;
  title: string;
  value: string | number;
};

const OverviewCard: React.FC<OverviewCardProps> = ({ color, icon, title, value }) => (
  <div className="col-md-4">
    <div className={`card bg-light-${color}`}>
      <div className="card-body">
        <KTIcon iconName={icon} className="fs-2" />
        <h4 className={`text-${color}`}>{title}</h4>
        <span className="fw-bold fs-1">{value}</span>
      </div>
    </div>
  </div>
);

export { ChartsWidget1 };
